<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Editar Proposta</mat-card-title>
    </div>
    <!--    @if (statusId == 3) {-->
    <!--      <button-->
    <!--        mat-flat-button-->
    <!--        class="btn-tg-white w-2/12"-->
    <!--        (click)="modalPurchases()"-->
    <!--      >-->
    <!--        Enviar Compras-->
    <!--      </button>-->
    <!--    }-->
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Voltar
    </button>
    @if (statusId != 1 && statusId != 5 && statusId != 6 && statusId != 9) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="!checkForm() || loading"
        (click)="editProposalClient()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Editar
        }
      </button>
    }
  </mat-card-header>
  <div class="my-4"></div>
  <div>
    @if (reason.motivoId && reason.motivoId > 0) {
      <div class="text-white font-bold bg-red-800 py-2 px-6 my-6">
        Reprovado por: {{ reason.motivoReprovacao }}
      </div>
    }

    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Proposta</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div [formGroup]="form" class="mt-4 container mx-auto">
            <div class="flex justify-between items-center mt-3 -mx-2">
              <!--              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
              <!--                <mat-label>Status Proposta</mat-label>-->
              <!--                <mat-select formControlName="statusProposal">-->
              <!--                  @for (type of ListProposalStatus; track type) {-->
              <!--                    <mat-option [value]="type.id">{{-->
              <!--                      type.descricao-->
              <!--                    }}</mat-option>-->
              <!--                  }-->
              <!--                </mat-select>-->
              <!--              </mat-form-field>-->
              <!--    </div>-->

              <!--    <div class="flex justify-between items-center mt-3 -mx-2">-->
              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Status Proposta</mat-label>
                <input matInput formControlName="statusProposal" />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Codigo tg</mat-label>
                <input matInput formControlName="tgCod" />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Data emissão</mat-label>
                <input matInput formControlName="dateEmission" />
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Nome evento</mat-label>
                <input matInput formControlName="eventName" />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Data inicio</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateStart"
                  (focus)="openDatepicker('dateStart')"
                  formControlName="dateStart"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateStart"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateStart></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Data fim</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateEnd"
                  (focus)="openDatepicker('dateEnd')"
                  formControlName="dateEnd"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateEnd"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateEnd></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="flex justify-between items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Cliente</mat-label>
                <input matInput formControlName="client" readonly />
                <!--                @if (this.form.get('client')!.enabled) {-->
                <!--                  <button mat-icon-button matSuffix (click)="addClient()">-->
                <!--                    <mat-icon>add</mat-icon>-->
                <!--                  </button>-->
                <!--                }-->
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Subcliente</mat-label>
                <input matInput formControlName="subClient" readonly />
                <!--                @if (this.form.get('subClient')!.enabled) {-->
                <!--                  <button mat-icon-button matSuffix (click)="addSubClient()">-->
                <!--                    <mat-icon>add</mat-icon>-->
                <!--                  </button>-->
                <!--                }-->
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Consultor Cliente</mat-label>
                <input matInput formControlName="consultant" readonly />
                @if (this.form.get('consultant')!.enabled) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="addConsultantClient()"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Consultor Comercial</mat-label>
                <input matInput formControlName="employeeConsultant" readonly />
                @if (this.form.get('employeeConsultant')!.enabled) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="addEmployeeConsultant()"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>

            <div class="flex justify-start items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Quant. passageiros</mat-label>
                <input matInput formControlName="numPassengers" integerInput />
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Forma/prazo de pagamento</mat-label>
                <mat-select formControlName="paymentMethod">
                  @for (type of ListPaymentMethods; track type) {
                    <mat-option [value]="type.id">
                      <span class="text-xs">{{ type.prazo }}</span
                      ><br />
                      <span class="text-sm">{{ type.tipoPagamento }}</span>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="w-full my-4">
              <div class="box-form">
                <h4 class="bg-gray">Solicitante</h4>
                <div class="input-box flex flex-col items-center w-full">
                  <!--                  <div class="flex justify-between items-center -mx-2 w-full">-->
                  <!--                    <mat-form-field-->
                  <!--                      class="input-tg w-full px-2"-->
                  <!--                      appearance="outline"-->
                  <!--                    >-->
                  <!--                      <mat-label>Responsáveis</mat-label>-->
                  <!--                      <mat-select-->
                  <!--                        formControlName="responsible"-->
                  <!--                        (selectionChange)="fillResponsible()"-->
                  <!--                      >-->
                  <!--                        @for (item of ListResponsible; track item) {-->
                  <!--                          <mat-option [value]="item">-->
                  <!--                            <span class="text-sm"-->
                  <!--                              >Nome: {{ item.nome }} | Email: {{ item.email }} |-->
                  <!--                              Telefone: {{ item.telefone }}</span-->
                  <!--                            >-->
                  <!--                          </mat-option>-->
                  <!--                        }-->
                  <!--                      </mat-select>-->
                  <!--                    </mat-form-field>-->
                  <!--                  </div>-->
                  <div class="flex justify-between items-center -mx-2 w-full">
                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Nome</mat-label>
                      <input
                        matInput
                        formControlName="requesterName"
                        readonly
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Email</mat-label>
                      <input
                        matInput
                        formControlName="requesterEmail"
                        readonly
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Telefone</mat-label>
                      <input
                        matInput
                        formControlName="requesterPhone"
                        [mask]="'(99) 99999-9999'"
                        readonly
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex justify-end items-center mt-4 mb-6 -mx-2">
              <mat-form-field
                class="input-tg w-3/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Total Geral</mat-label>
                @if (form.get('grandTotal')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="grandTotal" currencyInput />
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Itens proposta</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <item-proposal-edit
            [proposalInfo]="item.data"
            [idProposal]="item.data.id"
            [statusId]="statusId"
            (responseRefresh)="refreshProposal($event)"
          />
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Serviços adicionais</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <service-additional-proposal-edit
            [idProposal]="item.data.id"
            [proposal]="item.data"
            (responseRefresh)="refreshProposal($event)"
          />
          <!--          -->
          <!--          [proposalInfo]="item.data"-->
          <!--          [idProposal]="item.data.id"-->
          <!--          [statusId]="statusId"-->
          <!--          (responseRefresh)="refreshProposal($event)"-->
          <!--          -->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-card>
